import { useConstructorContextState } from './useConstructorContextState';
import { get } from 'lodash';

export const useGetIsWhitelabel = (): boolean => {
  const state = useConstructorContextState();

  return get(state, ['isWhitelabel'], false);
};
